import { SnomedCodeFull } from "@accurx/api/patient-messaging";
import { Log } from "@accurx/shared";
import { SnomedCode } from "domains/message-templates/types/SnomedCode";

export const mapSnomedCode = (
    snomedCode: SnomedCodeFull,
    templateId: string,
): SnomedCode | null => {
    if (snomedCode.conceptId === undefined || snomedCode.conceptId === null) {
        Log.error(
            "Unable to map SNOMED code with no ID attached to message template. Discarding SNOMED code.",
            { tags: { templateId, snomedTerm: snomedCode.term } },
        );
        return null;
    }

    return { id: snomedCode.conceptId, term: snomedCode.term };
};

export const mapSnomedCodes = (
    snomedCodes: SnomedCodeFull[] | null | undefined,
    templateId: string,
): SnomedCode[] | undefined => {
    return snomedCodes
        ?.map((snomedCode) => mapSnomedCode(snomedCode, templateId))
        .filter((s): s is SnomedCode => s !== null);
};
